import { render, staticRenderFns } from "./check.vue?vue&type=template&id=4b2e786a"
import script from "./check.vue?vue&type=script&lang=ts"
export * from "./check.vue?vue&type=script&lang=ts"
import style0 from "./check.vue?vue&type=style&index=0&id=4b2e786a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports